import * as React from 'react';
import { bool, number, string } from 'prop-types';
import styled from 'styled-components';

const mobileBreakpoint = '@media (max-width: 576px)';

const VideoContainer = styled.figure(props => ({
   textAlign: 'center',
   margin: 0,
}));

const Iframe = styled.iframe(props => ({
   margin: '0 auto',
   height: props.desktopHeight,
   width: props.desktopWidth,
   maxHeight: '100%',
   maxWidth: '100%',

   [mobileBreakpoint]: {
      height: props.mobileHeight,
      width: props.mobileWidth,
   },
}));

const Video = styled.video(props => ({
   margin: '0 auto',
   height: props.desktopHeight,
   width: props.desktopWidth,
   maxHeight: '100%',
   maxWidth: '100%',

   [mobileBreakpoint]: {
      height: props.mobileHeight,
      width: props.mobileWidth,
   },
}));

const VideoComponent = ({
   isEmbed,
   desktopWidth,
   desktopHeight,
   mobileWidth,
   mobileHeight,
   src,
   ...props
}) => (
   <VideoContainer>
      {isEmbed ? (
         <Iframe
            type="text/html"
            desktopWidth={desktopWidth}
            desktopHeight={desktopHeight}
            mobileWidth={mobileWidth}
            mobileHeight={mobileHeight}
            src={src}
            frameBorder="0"
            allowFullScreen
         />
      ) : (
         <Video
            desktopWidth={desktopWidth}
            desktopHeight={desktopHeight}
            mobileWidth={mobileWidth}
            mobileHeight={mobileHeight}
         >
            <source src={src} type="video/mp4" />
         </Video>
      )}
   </VideoContainer>
);

VideoComponent.propTypes = {
   desktopWidth: number,
   desktopHeight: number,
   mobileWidth: number,
   mobileHeight: number,
   isEmbed: bool.isRequired,
   src: string.isRequired,
};

VideoComponent.defaultProps = {
   isEmbed: false,
   desktopWidth: 640,
   desktopHeight: 360,
   mobileWidth: 278,
   mobileHeight: 156,
};

export default VideoComponent;
